/**
 * Created by vlad on 12.12.18.
 */

const DirtyHoneyDecoratorCellView = BaseCellView.extend({
    ctor: function (cell) {
        this._super();

        this.setContentSize2(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        this.initialize(cell);

        if (cell.isForGoal) {
            const styles = cleverapps.styles.DirtyHoneyDecoratorCellView;
            this.setContentSize2(styles.width, styles.height);
        }

        const image = this.image = new cc.Sprite(bundles.dirty_honey.frames.dirty_honey_decorator);
        image.setAlignment(this.width / 2, this.height / 2);
        this.addChild(image);
    },

    initialize: function (cell) {
        this._super(cell);

        cell.onCreateNew = this.createListener(this.animateCreateNew.bind(this));
    },

    animateCreateNew: function () {
        this.image.visible = false;
        BaseAnimation.runAnimate(this, bundles.dirty_honey.jsons.dirty_honey_json, "top_on", () => {
            this.image.visible = true;
        }, this.image);
        cleverapps.effects.fire(cleverapps.styles.DirtyHoneyDecoratorCellView.growUpEffect);
    },

    animateExplode: function () {
        this.setLocalZOrder(11);
        BaseAnimation.runAnimate(this, bundles.dirty_honey.jsons.dirty_honey_json, "top_off", this.image);
        cleverapps.effects.fire(cleverapps.styles.DirtyHoneyDecoratorCellView.dieEffect);
    }
});

cleverapps.styles.DirtyHoneyDecoratorCellView = {
    width: 120,
    height: 120,
    growUpEffect: "match3.dirty_honey.create",
    dieEffect: "match3.element.die"
};